import { Nullish } from '../../Utility/Nullish';

export interface ManifestDefaultItem {
    id: string;
    animation: string | null;
    x: string | number;
    y: string | number;
    width: string | number;
    height: string | number;
    z: string | number;
}

interface ManifestDefaultTextbox extends ManifestDefaultItem {
    text: string;
}

export interface ManifestDefaultShape extends ManifestDefaultItem {
    color: string;
    type: string; // 'rect' | 'ellipse' | 'rectangle';
}

export interface ManifestDefaultImage extends ManifestDefaultItem {
    imgpath: string;
}

export interface ManifestBase {
    template: string;
    ann_seconds: number | string | Nullish;
    announcement_id: number | string;
    announcement_order: number | string;
    announcement_name: string;
    date_start: string;
    date_end: string;
    ann_status: string;
    screen_alert: string | Nullish;
    updated_timestamp: number | string | Nullish;
    width: number | string | Nullish;
    height: number | string | Nullish;
    run_days: unknown;
    run_stime: unknown;
    run_etime: unknown;
    go_full_screen: 'true' | 'false' | Nullish;

    background_color: unknown;
    group_id: unknown;
    media_library_item_id: unknown;
}
export function isManifestItem(item: unknown): item is ManifestBase {
    return item instanceof Object && 'template' in item;
}

interface ManifestDefault extends ManifestBase {
    template: 'default';
    bgimg: string | null;
    textboxes: Array<ManifestDefaultTextbox>;
    shapes: Array<ManifestDefaultShape>;
    images: Array<ManifestDefaultImage>;
}
export function isManifestDefault(item: unknown): item is ManifestDefault {
    return isManifestItem(item) && 'default' === item.template;
}

interface ManifestVideoBase extends ManifestBase {
    video_total_duration: number | string;
    video_start_time: number | string;
}
interface ManifestReachVideo extends ManifestVideoBase {
    template: 'video';
    video_id: string;
}
export function isManifestReachVideo(item: unknown): item is ManifestReachVideo {
    return isManifestItem(item) && 'video' === item.template;
}
interface ManifestYoutube extends ManifestVideoBase {
    template: 'youtube';
    youtubelink: string;
    youtube_enable_cc: string;
}
export function isManifestYoutube(item: unknown): item is ManifestYoutube {
    return isManifestItem(item) && 'youtube' === item.template;
}
interface ManifestVimeo extends ManifestVideoBase {
    template: 'vimeo';
    vimeo_video_id: string;
    youtube_enable_cc: string;
}
export function isManifestVimeo(item: unknown): item is ManifestVimeo {
    return isManifestItem(item) && 'vimeo' === item.template;
}
interface ManifestKaltura extends ManifestVideoBase {
    template: 'kaltura';
    video_id: string;
    alt_url: string;
}
export function isManifestKaltura(item: unknown): item is ManifestKaltura {
    return isManifestItem(item) && 'kaltura' === item.template;
}
export type ManifestVideo = ManifestReachVideo | ManifestYoutube | ManifestVimeo | ManifestKaltura;
export function isManifestVideo(item: unknown): item is ManifestVideo {
    return isManifestItem(item) && ['video', 'youtube', 'vimeo', 'kaltura'].includes(item.template);
}

type ManifestItem = ManifestBase | ManifestDefault | ManifestVideo;

export interface AnnouncementManifest {
    announcements: Array<ManifestItem>;
    hash: string;
}
